<bzg-modal-header>
  <span class="bmc-confirm-confirmation__header bzg-modal__header" [ngClass]="getColorHeader()">
    {{ data.titleModal | translate | titlecase }}
  </span>
</bzg-modal-header>
<bzg-modal-content class="bmc-confirm-alert__body">
  <span [innerHTML]="data.messageModal | translate"></span>
</bzg-modal-content>
<bzg-modal-footer class="bmc-confirm-alert__footer">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ data.messageButtonCancel || 'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="confirm()" [ngClass]="getColorButton()">{{ data.messageButtonConfirmation || 'GLOBAL.SAVE' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
